import { fitroomViewportModuleContext } from '@seddi/ui-babylon-fitroom';
import { fetchPose } from '../../avatars';
import { SessionStorage } from '../../session';
import { homeActions } from '../slices/homeSlice';
import { HomeDispatch, HomeGetState } from '../store/homeStore';
import { homeStateExt } from '../store/homeStateExt';
import { updateGarment } from './homeGarment';

/**
 * Change avatar pose state and scene.
 * @param dispatch Redux dispatch function.
 * @param getState Redux state accessor.
 * @param poseId the pose ID.
 */
export async function setPose(dispatch: HomeDispatch, getState: HomeGetState, poseId: string) {
  // Update state.
  dispatch(homeActions.setPose(poseId));

  // Update cache.
  SessionStorage.pushData({ poseId });

  const pose = await fetchPose(poseId);

  // Update avatar visualization.
  const context = fitroomViewportModuleContext();
  await context.updateAvatarGeometry({ pose });

  const { garmentId } = getState();
  if (!garmentId) {
    return;
  }

  // Update fit.
  const garment = homeStateExt.garment!;
  updateGarment(dispatch, getState, garment);
}
